(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = (track) => {
      if (track.dataset.wpStarted) return;
      track.dataset.wpStarted = '1';
      const items = track.querySelectorAll('.wp-announce__item');
      if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (Number(track.dataset.wpRotate) || 4) * 1000);
    };
    const init = () => document.querySelectorAll('[data-wp-rotate]').forEach(start);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-collection"]) return;
  try {
    
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-wp-sort]')) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-size-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wp-size-finder')) {
    const num = (v) => Number(String(v || '').replace(/[٠-٩]/g, (c) => c.charCodeAt(0) - 0x0660).replace(/[^\d.]/g, ''));
    const range = (t) => {
      const [min, max] = String(t).split(/[-–]/).map(num);
      return { min, max: max || min };
    };
    const within = (v, r) => v >= r.min && v <= r.max;

    customElements.define(
      'wp-size-finder',
      class extends HTMLElement {
        connectedCallback() {
          this.rows = [...this.querySelectorAll('[data-size]')].map((el) => ({
            el,
            size: el.dataset.size,
            height: range(el.dataset.height),
            weight: range(el.dataset.weight),
          }));
          this.inputs = [...this.querySelectorAll('input[type="range"]')];
          this.inputs.forEach((input) => input.addEventListener('input', () => this.update()));
          this.update();
        }

        pick(h, w) {
          const rows = this.rows;
          const byWeight = rows.filter((r) => within(w, r.weight));
          if (!byWeight.length) {
            return {
              row: w < rows[0].weight.min ? rows[0] : rows[rows.length - 1],
              note: 'Outside our chart — message us on WhatsApp and we will help.',
            };
          }
          const both = byWeight.filter((r) => within(h, r.height));
          if (both.length > 1) {
            const row = both[both.length - 1];
            return { row, note: `Between ${both[0].size} and ${row.size} — we suggest ${row.size} for a relaxed fit.` };
          }
          if (both.length === 1) return { row: both[0], note: 'A great match for your height and weight.' };
          const row = byWeight[byWeight.length - 1];
          return {
            row,
            note: h < row.height.min ? 'The leg will fall a little long — perfect with heels.' : 'The leg will sit slightly higher for a cropped look.',
          };
        }

        update() {
          if (!this.rows.length) return;
          const values = {};
          this.inputs.forEach((input) => {
            values[input.name] = num(input.value);
            const pct = ((input.value - input.min) / (input.max - input.min)) * 100;
            input.style.setProperty('--fill', pct + '%');
            const out = this.querySelector(`[data-out="${input.name}"]`);
            if (out) out.textContent = input.value;
          });
          const { row, note } = this.pick(values.height, values.weight);
          this.rows.forEach((r) => r.el.classList.toggle('is-active', r === row));
          const size = this.querySelector('[data-result-size]');
          if (size.textContent !== row.size) {
            size.textContent = row.size;
            size.classList.remove('is-pop');
            void size.offsetWidth;
            size.classList.add('is-pop');
          }
          this.querySelector('[data-result-note]').textContent = note;
          const shop = this.querySelector('[data-shop]');
          shop.textContent = `Shop size ${row.size}`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
